import axios from "axios";
import qs from "qs";

export function createApiClient(baseUrl) {
  const resolveUrl = (path) => `${baseUrl}${path}`;

  return {
    get(path, params) {
      return axios.get(resolveUrl(path), { params });
    },
    postForm(path, params) {
      return axios.post(resolveUrl(path), qs.stringify(params));
    },
  };
}

export function createApiService(client, specs) {
  const service = {};

  Object.keys(specs).forEach((name) => {
    const [method, path] = specs[name];
    if (method === "get") {
      service[name] = (params) => client.get(path, params);
      return;
    }
    if (method === "postForm") {
      service[name] = (params) => client.postForm(path, params);
      return;
    }
    throw new Error(`Unsupported method in createApiService: ${method}`);
  });

  return service;
}
